<template>
  <v-app id="inspire">
    <v-navigation-drawer
      :dark="theme != 'light'"
      color=" en-3"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      :mini-variant="!drawer"
      class="navigation"
      :permanent="permanent"
    >
      <!-- <v-parallax

        height="100%"
        src="https://static.vecteezy.com/system/resources/previews/000/549/665/non_2x/abstract-backgro d--and-black-overlaps-004-vector.jpg"
      >-->
      <v-list class="alignmentfixes" dense>
        <template v-for="item in menuItemList">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDITt</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item['icon-alt'] : item.icon"
            dense
          >
            <v-icon slot="prependIcon" large color="#1d2939">
              {{ item.model ? item['icon-alt'] : item.icon }}
            </v-icon>

            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="sidebar">{{
                  item.text
                }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <div v-for="(child, i) in item.children">
              <div v-for="menuOpt in childMenuItemList">
                <v-list-item
                  v-if="child.text == menuOpt.text"
                  :key="i"
                  :to="child.link"
                  link
                  v-ripple="{ class: 'ripple_color' }"
                  :style="drawer ? '' : 'background-color:#b0d7ff7a'"
                >
                  <v-list-item-action
                    v-if="child.icon"
                    :class="!drawer ? '' : 'ml-4'"
                  >
                    <v-icon>{{ child.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="sidebar">{{
                      child.text
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </div>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.text"
            link
            :to="item.link"
            v-ripple="{ class: 'ripple_color' }"
          >
            <v-list-item-action class>
              <v-icon color="#1d2939">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="sidebar">{{
                item.text
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <!-- </v-parallax> -->
    </v-navigation-drawer>

    <!-- color="white" -->
    <v-app-bar
      :dark="theme != 'light'"
      :color="theme == 'light' ? 'white' : 'black_bar'"
      height="50"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      flat
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title
        style="width: 200px"
        class="ml-0 pl-4 text-left d-none d-sm-flex"
      >
        <span class="brand_name">{{ sitename }}</span>
      </v-toolbar-title>
      <v-row align="center" class="layout_responsive">
        <v-col sm="2" cols="2" lg="2" class="global_search d-none d-md-flex">
        </v-col>
        <v-col sm="4" cols="4" lg="4" class="global_search d-none d-md-flex">
        </v-col>
      </v-row>

      <v-menu
        transition="slide-y-transition"
        bottom
        :nudge-width="200"
        content-class="my-menu"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on, $attrs }">
          <v-btn
            class="shadow"
            color="transparent"
            dark
            v-on="on"
            v-bind="$attrs"
          >
            <svg
              v-if="!color_mode"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              aria-hidden="true"
              focusable="false"
              width="2em"
              height="3em"
              style="
                -ms-transform: rotate(360deg);
                -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
              "
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                d="M4 6h2v12H4V6m3 0h1v12H7V6m2 0h3v12H9V6m4 0h1v12h-1V6m3 0h2v12h-2V6m3 0h1v12h-1V6M2 4v4H0V4a2 2 0 0 1 2-2h4v2H2m20-2a2 2 0 0 1 2 2v4h-2V4h-4V2h4M2 16v4h4v2H2a2 2 0 0 1-2-2v-4h2m20 4v-4h2v4a2 2 0 0 1-2 2h-4v-2h4z"
                fill="white"
              />
            </svg>
            <svg
              v-if="color_mode"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              aria-hidden="true"
              focusable="false"
              width="2em"
              height="3em"
              style="
                -ms-transform: rotate(360deg);
                -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
              "
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                d="M4 6h2v12H4V6m3 0h1v12H7V6m2 0h3v12H9V6m4 0h1v12h-1V6m3 0h2v12h-2V6m3 0h1v12h-1V6M2 4v4H0V4a2 2 0
                 0 1 2-2h4v2H2m20-2a2 2 0 0 1 2 2v4h-2V4h-4V2h4M2 16v4h4v2H2a2 2 0 0 1-2-2v-4h2m20 4v-4h2v4a2 2 0 0 1-2 2h-4v-2h4z"
                fill="#626262"
              />
            </svg>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-row>
              <v-col cols="7">
                <v-text-field
                  v-model="barcode"
                  autofocus
                  placeholder="Scan Barcode"
                  @input="barcodeErrorMessage = null"
                  error-messages="barcodeErrorMessage"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="5">
                <v-btn small @click="GetBatchByBarcode(barcode)">
                  search
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item v-if="barcodeErrorMessage">
            <div style="color: darkred">{{ barcodeErrorMessage }}</div>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, $attrs }">
          <v-btn
            icon
            @click="color_mode = !color_mode"
            v-bind="$attrs"
            v-on="on"
            class="mr-1"
          >
            <img
              style="fill: white"
              src="../../../assets/light-on.png"
              height="20"
              v-show="!color_mode"
            />
            <img
              src="../../../assets/moon.png"
              height="20"
              v-show="color_mode"
            />
          </v-btn>
        </template>
        <span>{{ color_mode ? 'Dark' : 'Light' }}Mode</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, $attrs }">
          <v-btn
            @click="GoToEvents"
            icon
            class="mr-1"
            v-bind="$attrs"
            v-on="on"
          >
            <img
              style="fill: white"
              src="../../../assets/event.png"
              height="25"
            />
          </v-btn>
        </template>
        <span>Events</span>
      </v-tooltip>

      <Calculator flat icon>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, $attrs }">
            <v-btn
              icon
              class="mr-1"
              v-bind="$attrs"
              v-on="on"
              @click="opencalculator"
            >
              <img
                style="fill: white"
                src="../../../assets/calculator.png"
                height="25"
              />
            </v-btn>
          </template>
          <span>Calculator</span>
        </v-tooltip>
      </Calculator>

      <v-menu v-if="!isMobile()" offset-y transition="scroll-y-transition">
        <template v-slot:activator="{ on: menu, $attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                depressed
                class="theme2"
                height="48"
                v-bind="$attrs"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-img class="addIcon" src="@/assets/add.png"></v-img>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in productLists"
            :key="index"
            :to="item.link"
          >
            <v-list-item-title>
              <v-icon class="icon_small ma-2">{{ item.icon }}</v-icon>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-tooltip v-if="!isMobile()" bottom>
        <template v-slot:activator="{ on, $attrs }">
          <v-btn
            depressed
            v-bind="$attrs"
            v-on="on"
            @click="gotopos()"
            target="_blank"
            class="theme2"
            height="48"
          >
            <v-img class="addIcon" src="@/assets/pos3.png"></v-img>

            <section class="btn_responsive"></section>
          </v-btn>
        </template>
        <span>POS</span>
      </v-tooltip>

      <!-- <v-col
          v-if="false"
          class="global_search d-none d-md-flex"
          sm="1"
          cols="1"
          lg="1"
        >
          <v-text-field
            placeholder="Tell me what you want to do"
            single-line
            outlined
            hide-details
            prepend-icon="mdi-lightbulb-on"
          ></v-text-field>
        </v-col> -->

      <!-- Add New Button -->

      <v-tooltip bottom>
        <template v-slot:activator="{ on, $attrs }">
          <v-btn icon v-bind="$attrs" v-on="on">
            <Notification> </Notification>
          </v-btn>
        </template>
        <span>Notifications</span>
      </v-tooltip>
      <span class="d-none d-sm-flex">
        {{ user ? user.first_name : '' }}
      </span>

      <v-btn icon>
        <UserMenuComponent></UserMenuComponent>
      </v-btn>
    </v-app-bar>
    <v-main>
      <router-view />
    </v-main>
    <v-footer padless>
      <v-col class="text-center" cols="12">
        <strong>
          {{ new Date().getFullYear() }} @ Copyright — Inventory & POS by Speed
          Code Labs (Pvt) Ltd
        </strong>
      </v-col>
    </v-footer>
  </v-app>

  <!-- Report New Buton -->
  <!-- <v-col cols="1" sm="2" md="1" lg="1" class=" pl-5 ">
       
        <v-menu offset-y transition="scroll-y-transition">
           <template v-slot:activator="{ on: menu, $attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  depressed
                  x-small
                  style="margin-left: 30px;"
                  height="28"
                  class="theme1 w-100 btn_blue add_btn pa-0  d-none d-sm-flex"
                  v-bind="$attrs"
                  v-on="{ ...tooltip, ...menu }"
                >
                  <v-icon class=" ma-2" x-small>mdi-export </v-icon>

                  <section class="btn_responsive">
                    <v-icon class="ma-2" x-small>mdi-menu-down </v-icon>
                  </section>
                </v-btn>
              </template>
              <span>Reports</span>
            </v-tooltip>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in reportLists"
              :key="index"
              :to="item.link"
            >
              <v-list-item-title>
                <v-icon class="icon_small ma-2">{{ item.icon }}</v-icon>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col> -->
</template>

<script>
import _ from 'lodash';
import UserMenuComponent from './user.menu';
import Notification from './notification';
import env from '../../../config/env';
import { mapState, mapGetters } from 'vuex';
import Loading from '@/components/shared/routeLoading.vue';
import Calculator from '../../../components/shared/Calculator.vue';
import store from '@/store/store';
export default {
  components: {
    UserMenuComponent,
    Notification,
    Loading,
    Calculator,
  },
  props: {
    source: String,
  },
  data: () => ({
    on: {
      click: console.log,
      contextmenu: console.log,
    },
    inheritAttrs: false,
    barcode: null,
    barcodeErrorMessage: null,
    sitename: '',
    dialog: false,
    drawer: false,
    itemList: [],
    permissionsData: [],
    productLists: [],
    reportLists: [],
    menuItemList: [],
    childMenuItemList: [],

    input1: '',
    ListOfAdds: [
      {
        text: 'Add Product',
        icon: 'mdi-layers-triple-outline',
        link: '/product/add',
        policy: ['Product Create'],
      },
      {
        text: 'Add Purchase Order',
        icon: 'mdi-storefront-outline',
        link: '/purchase-order/add',
        policy: ['Purchase Order Create'],
      },
      {
        text: 'Add Purchase',
        icon: 'mdi-truck-check-outline',
        link: '/purchase/add',
        policy: ['Purchase Create'],
      },
      {
        text: 'Add Purchase Return',
        icon: 'mdi-truck-delivery-outline',
        link: '/purchase-return/add',
        policy: ['Purchase Return Create'],
      },
      {
        text: 'Add Supplier',
        icon: 'mdi-account-details-outline',
        link: '/supplier/add',
        policy: ['Supplier Create'],
      },
      {
        text: 'Add Customer',
        icon: 'mdi-account-multiple-outline',
        link: '/customer/add',
        policy: ['Customer Create'],
      },
      // { text: "Add WareHouse", icon: "mdi-store", link: "/setting/warehouse" },
      // { text: "Add Category", icon: "mdi-tag", link: "/setting/category" },
    ],
    ListOfReports: [
      {
        text: 'Product',
        icon: 'mdi-layers-triple-outline',
        link: '/product-report',
        policy: ['Product Report Index'],
      },
      {
        text: 'Purchase Order',
        icon: 'mdi-storefront-outline',
        link: '/purchase-order-report',
        policy: ['PurchaseOrder Report Index'],
      },
      {
        text: 'Purchase',
        icon: 'mdi-truck-check-outline',
        link: '/purchase-report',
        policy: ['Purchase Report Index'],
      },
      {
        text: 'Purchase Return',
        icon: 'mdi-truck-delivery-outline',
        link: '/purchase-return-report',
        policy: ['PurchaseReturn Report Index'],
      },
      {
        text: 'Out Of Stock',
        icon: 'mdi-store-plus',
        'icon-alt': 'mdi-store',
        link: '/out-of-stock-report',
        policy: ['Out Of Stocks Report Index'],
      },
      {
        text: 'Low Stock',
        icon: 'mdi-store-remove',
        'icon-alt': 'mdi-store',
        link: '/low-stock-report',
        policy: ['Low Stocks Report Index'],
      },
      {
        text: 'Sales',
        icon: 'mdi-sack-percent',
        'icon-alt': 'mdi-account-multiple-plus',
        link: '/sales-report',
        policy: ['Sales Report Index'],
      },
    ],
  }),
  watch: {
    // color_mode: function() {
    //   this.$store.commit("SET_COLOR_MODE", this.color_mode);
    // },
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    opencalculator() {
      this.$store.dispatch('calculatorVisible', true);
    },
    GoToEvents() {
      this.$router.push('/event');
    },
    gotopos() {
      window.open(this.$store.state.pos_url, '_blank');
    },
    GetBatchByBarcode(barcode) {
      this.$store
        .dispatch('product/GetProductBatchByBarcode', barcode)
        .then((res) => {
          this.$router.push(`/product/${res.id}/batch/${res.batch_id}`);
        })
        .catch((err) => {
          this.barcodeErrorMessage = err.data;
        });
    },

    checkPermission(policy) {
      // this.items.map((item) => {
      //   let permission = this.$store.state.user.policies;
      //   var hasPermission = _.find(permission, function(permission) {
      //     return permission.name == item.policy;
      //   });

      //   if (hasPermission) {
      //     this.itemList.push(item);
      //   }
      // });

      this.GetMenuList.map((item) => {
        let permission = this.$store.state.user.policies;
        var hasPermissions = _.find(permission, function (permission) {
          return permission?.name == item?.policy;
        });
        if (hasPermissions) {
          this.menuItemList.push(item);
        }
        if (item.children) {
          let permission = this.$store.state.user.policies;
          item.children.map((i) => {
            var childHasPermission = _.find(permission, function (permission) {
              return permission.name == i.policy;
            });
            if (childHasPermission) {
              this.childMenuItemList.push(i);
            }
          });
        }
      });

      this.ListOfAdds.map((item) => {
        let permission = this.$store.state.user.policies;
        var hasPermissions = _.find(permission, function (permission) {
          return permission.name == item.policy;
        });
        if (hasPermissions) {
          this.productLists.push(item);
        }
      });

      this.ListOfReports.map((item) => {
        let permission = this.$store.state.user.policies;
        var hasPermissions = _.find(permission, function (permission) {
          return permission.name == item.policy;
        });
        if (hasPermissions) {
          this.reportLists.push(item);
        }
      });
    },
  },
  mounted: function () {
    this.checkPermission();
  },
  created() {
    if (localStorage.getItem('user') != null) {
      this.permissionsData = store.state.user.policies;
    }
    this.sitename = this.$store.state.sitesetting.name;

    this.$store.subscribe((mutation, state) => {
      this.sitename = state.sitesetting.name;
    });
    let self = this;
    setInterval(function () {
      self.$store.dispatch('common/notifications');
    }, 300000);
  },

  computed: {
    // sitename() {
    //   return this.$store.state.sitesetting.name;
    // },
    color_mode: {
      get() {
        return this.theme == 'light';
      },
      set(value) {
        this.$store.commit('SET_COLOR_MODE', value);
      },
    },
    isLoading: function () {
      return this.$root.loading;
    },
    ...mapState(['name', 'theme']),
    ...mapState('user', ['user']),
    ...mapGetters('user', ['GetMenuList']),
    permanent: {
      get: function () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return !true;
          case 'sm':
            return !true;
          case 'md':
            return !true;
          case 'lg':
            return !false;
          case 'xl':
            return !false;
        }
      },
      set: function (value) {
        this.drawer = value;
      },
    },
    name() {
      return env.name;
    },
  },
};
</script>
<style>
/* global_search  */
.global_search fieldset {
  border: unset !important;
}

.global_search .v-input__prepend-outer {
  margin-top: 4px !important;
}

.global_search .v-input__prepend-outer .v-icon {
  font-size: 18px !important;
}

@media screen and (max-width: 1251px) {
  .alignmentfixes {
    margin-top: 15% !important;
  }
}

.global_search .v-input__slot {
  margin-left: -15px;
}

.global_search .v-input input {
  padding-left: 16px;
  /* background: #f7f7f796; */
  border-radius: 8px;
  color: #565656;
}

.global_search .v-input input:focus {
  color: black;
  padding-left: 16px;
  background: #f7f7f7;
  border-radius: 8px;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

.theme-light {
  --color-primary: #0060df;
  --color-secondary: #fbfbfe;
  --color-accent: #fd6f53;
  --font-color: #000000;
}

.theme-dark {
  --color-primary: #17ed90;
  --color-secondary: #2a2c2d;
  --color-accent: #12cdea;
  --font-color: #ffffff;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 14;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 50px;
  height: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #eaeaea;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.addIcon {
  width: 10px;
  height: 25px;
}

.ScannerIcon {
  width: 40px;
  height: 40px;
}

.slider:before {
  position: absolute;
  content: '';
  height: 18px;
  width: 18px;
  left: 0px;
  bottom: 4px;
  top: 50;
  bottom: 0;
  margin: auto 0;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  box-shadow: 0 0px 15px #2020203d;
  background: white url('../../../assets/img/night.png');
  background-repeat: no-repeat;
  background-position: center;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(17px);
  -ms-transform: translateX(17px);
  transform: translateX(17px);
  background: white url('../../../assets/img/sunny.png');
  background-repeat: no-repeat;
  background-position: center;
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.my-menu {
  margin-top: 40px;
  contain: initial;
  overflow: visible;
}
.my-menu::before {
  position: absolute;
  content: '';
  top: 0;
  left: 10px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;

  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #fff;
}
.shadow {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.theme1 {
  background-color: #8d918d !important;
  border-radius: 10px !important;
  color: #ffffff !important;
}

.theme2 {
  background-color: transparent !important;
}
.btn_responsive {
  max-width: -moz-available;
}
.theme--light.v-app-bar.v-toolbar.v-sheet {
  z-index: 17 !important;
}

@media only screen and (max-width: 1400px) {
  .btn_responsive {
    font-size: 12px !important;
  }
  @media only screen and (max-width: 1000px) {
    .btn_responsive {
      display: none !important;
    }
    @media only screen and (max-width: 700px) {
      .layout_responsive .v-btn {
        height: 30px !important;
        width: 50px !important;
        min-width: 10px !important;
      }
      .v-toolbar__title {
        width: 100px !important;
      }
      .brand_name {
        font-weight: bolder !important;
        font-size: 12px;
        color: #031a61;
      }
    }
  }
}
@media only screen and (max-width: 300px) {
  .align1 {
    top: 50px !important;
  }
}
</style>
